import { useState, useMemo, useEffect } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { ProductCard } from '@/components';
import Skeleton from 'react-loading-skeleton';
import ecommerce from '@/seo/Ecommerce';
import getLinkProps from '@/lib/getLinkProps';
import styles from './Products.module.scss';

const Products = ({
	products,
	loading: loadingProducts,
	productCardProps,
	isSafari,
	currency,
	slug,
	state,
}) => {
	const [items, setItems] = useState(products);
	const [loading, setLoading] = useState(true);
	const [skeleton, setSkeleton] = useState([true]);

	const getLink = slug => {
		const [, linkAs] = getLinkProps({ type: 'product', value: slug });
		return linkAs;
	};

	const nameCategory = useMemo(() => {
		let nameSlug = 'Категории';

		if (slug.includes('brand')) {
			nameSlug = 'Бренды';
		} else if (slug.includes('sale')) {
			nameSlug = 'Распродажи/Sale';
		}

		return `Каталог товаров: ${nameSlug}`;
	}, [slug]);

	useEffect(() => {
		const goods = [...products];

		setItems(goods);
	}, [products]);

	useEffect(() => {
		if (loadingProducts) {
			setLoading(true);
		} else {
			setTimeout(() => {
				setLoading(false);
			}, 0);
		}
	}, [loadingProducts]);

	useEffect(() => {
		if (loading) {
			const interval = setInterval(() => {
				setSkeleton(prevState => {
					if (prevState.length < 6) {
						return [...prevState, true];
					}

					return prevState;
				});
			}, 250);

			return () => clearInterval(interval);
		} else {
			setSkeleton([true]);
		}
	}, [loading]);

	const handleClickCard = (product, index) => {
		ecommerce.viewItemList([product], currency, nameCategory, 'select_item', index);
	};

	return (
		<ul className={styles.productList}>
			{loading ? (
				<>
					{skeleton.map((_item, idx) => {
						return (
							<li key={idx} className={styles.productListLoading}>
								<Skeleton
									key={`${idx}-skeleton-product1`}
									count={1}
									height='70%'
									width='100%'
									style={{ marginBottom: '24px' }}
								/>
								<Skeleton
									key={`${idx}-skeleton-product2`}
									count={1}
									height='5%'
									width='30%'
									style={{ marginBottom: '8px' }}
								/>
								<Skeleton
									key={`${idx}-skeleton-product3`}
									count={1}
									height='7%'
									width='100%'
									style={{ marginBottom: '8px' }}
								/>
								<Skeleton
									key={`${idx}-skeleton-product4`}
									count={1}
									height='5%'
									width='35%'
									style={{ marginBottom: '8px' }}
								/>
							</li>
						);
					})}
				</>
			) : (
				<TransitionGroup component={null} exit={false}>
					{items.map((item, ind) => {
						const { external_id } = item;

						return (
							<CSSTransition
								in
								key={external_id}
								timeout={{
									appear: 0,
									enter: 250,
									exit: 0,
								}}
								classNames='on'
							>
								<li id={getLink(item.model.slug)} itemType='https://schema.org/Product' itemScope>
									<div
										onClick={() => {
											handleClickCard(item, ind + 1);
										}}
									>
										<ProductCard
											{...item}
											{...productCardProps}
											isSafari={isSafari}
											pageName={nameCategory}
											indexCard={ind + 1}
											newCurrency={currency}
											state={state}
										/>
									</div>
								</li>
							</CSSTransition>
						);
					})}
				</TransitionGroup>
			)}
		</ul>
	);
};

export default Products;
